import React, { Component } from 'react';
import utils from '../utils/index.jsx';

import abi_CIROMINING from "../abi/cirofee";

const BigNumber = require('bignumber.js');

const tronWeb = utils.tronWeb
const adapter = utils.adapter

let Intervalo = null;

class Buyer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      estatus: {},
      contractready: false,
      contrato: {},
      wallet: "Loading...",
      energiaDisponible: new BigNumber(0),
      energiaEnVenta: new BigNumber(0),
      ciroRecibe: new BigNumber(0),
      trxDelegate: new BigNumber(1),
      energyDelegate: new BigNumber(1),
      receiverAddress: "TRrhyn55AtGEjgaLpj9sTbRGhqzVJ8ueNs",
      resource: "ENERGY",
      energyPrice: new BigNumber(0),
    }

    this.setEnergiaEnVenta = this.setEnergiaEnVenta.bind(this);
    this.sellEnergy = this.sellEnergy.bind(this);

    this.claimCiro = this.claimCiro.bind(this);

  }

  componentDidMount() {
    document.title = "Energy Rent | CiroTrx"

    setTimeout(async () => {
      await this.conectar();
      if (this.state.estatus['loggedIn'] && this.state.contractready) {
        this.estado();

      }
    }, 3 * 1000);

    Intervalo = setInterval(async () => {

      if (this.state.estatus['loggedIn'] && this.state.contractready) {
        this.estado();
      }

    }, 30 * 1000);
  }

  componentWillUnmount() {
    clearInterval(Intervalo);
  }

  async conectar() {

    let { estatus, wallet, contrato } = this.state;

    if (typeof window.tronWeb !== 'undefined') {


      await adapter.connect()
        .catch((e) => {
          console.log(e)
          alert(e.toString())
        })

      //console.log(adapter)

      if (adapter.address) {
        console.log("%c TronLink Conectado", "color:green");
        estatus["loggedIn"] = true
        wallet = adapter.address

      } else {
        estatus["loggedIn"] = false
        wallet = "T9yD14Nj9j7xAB4dbGeiX9h8unkKHxuWwb"

      }

      contrato['web3'] = tronWeb;
      contrato['web3'].setAddress(wallet)

      this.setState({
        estatus,
        wallet

      });

      if (!this.state.contractready) {
        if (utils.SC !== "") {

          // ciro mining MAINNET network tron = TUoBCXBJFFpbSniWYMrdo63FbjXCF1wTuF
          contrato.ciro_mining = await contrato['web3'].contract(abi_CIROMINING, "TUoBCXBJFFpbSniWYMrdo63FbjXCF1wTuF");

          this.setState({
            contrato,
            contractready: true
          });

          this.estado()

        }
      }

    } else {


      this.setState({
        wallet: wallet

      });


    }
  }

  async estado() {

    let { energyPrice, bandPrice, wallet, energiaDisponible } = this.state

    try {

      let recursos = await tronWeb.trx.getAccountResources(wallet)

      energyPrice = 1 / recursos.TotalEnergyWeight * recursos.TotalEnergyLimit
      bandPrice = 1 / recursos.TotalNetWeight * recursos.TotalNetLimit

      if (recursos.EnergyLimit) {
        energiaDisponible = new BigNumber(recursos.EnergyLimit)

        if (recursos.EnergyUsed) {
          energiaDisponible = energiaDisponible.minus(recursos.EnergyUsed)
        }
      }


    } catch (error) {
      console.log("Error consulta de recuros: ", error.toString())
    }

    this.setState({
      energyPrice,
      bandPrice,
      energiaDisponible

    })


  }

  setEnergiaEnVenta() {

    const { energyPrice, energiaDisponible } = this.state
    let energyDelegate = parseInt(document.getElementById("energy").value)

    if (isNaN(energyDelegate)) {
      energyDelegate = 0
      if ((document.getElementById("energy").value).length > 0) {
        document.getElementById("energy").value = 0

      }
    }



    energyDelegate = new BigNumber(energyDelegate)
    if (energyDelegate.toNumber() > energiaDisponible.toNumber()) {
      energyDelegate = energiaDisponible
    }

    this.setState({
      energyDelegate,
      trxDelegate: energyDelegate.div(energyPrice)
    })
  }

  async sellEnergy() {

    let { trxDelegate, receiverAddress, resource, wallet } = this.state

    let transaction = await tronWeb.transactionBuilder.delegateResource(trxDelegate.shiftedBy(6).dp(0).toString(10), receiverAddress, resource, wallet, false, 86400 / 3, {})
      .catch((e) => { console.log(e); return false })
    if (!transaction) return;

    transaction = await adapter.signTransaction(transaction)
      .catch((e) => { console.log(e); return false })
    if (!transaction) return;

    tronWeb.trx.sendRawTransaction(transaction)
      .then(() => {
        alert("operation complited")
      })
      .catch((e) => {
        alert(e.toString())
        console.log(e)
      })

    /*
            let transaction2 = await tronWeb.transactionBuilder.undelegateResource(trxDelegate.shiftedBy(6).dp(0).toString(10), receiverAddress, resource, wallet, {})
            .catch((e)=>{console.log(e); return false})
            if(!transaction2) return;
    
            transaction2 = await adapter.signTransaction(transaction2)
            .catch((e)=>{console.log(e); return false})
            if(!transaction2) return;
    
            tronWeb.trx.sendRawTransaction(transaction)
            .then(()=>{
              tronWeb.trx.sendRawTransaction(transaction2)
              .catch(console.error)
              .then(()=>{
                alert("operation complited 2")
              })
            })
            .catch(console.error)
    */




  }

  async claimCiro() {

    const { contrato, wallet } = this.state

    await contrato.ciro_mining.witdrwalPartial(wallet).send();

  }

  render() {
    let { trxDelegate, ciroRecibe, energiaDisponible, energyDelegate } = this.state

    return (<>
      <div className="contact-form-area style-two pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="dreamit-section-title text-center upper1 pb-70">
              <h1 className="section-title">Earn TRX Rewards by Lending Your Energy</h1>
              <p>Maximize your unused energy! Delegate your energy to CiroTRX for 30 days and receive instant TRX rewards directly to your wallet.</p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 col-sm-12">
              <div className="contact-form-box wow fadeInUp text-center" data-wow-delay=".4s">
                <div className="contact-form-title">
                  <h3 className="pb-4">Delegate Energy & Earn</h3>
                  <div className=" justify-content-between align-items-center mb-5">

                    <h6>Your Energy Available: <span id="energy-needed">{energiaDisponible.toString(10)}</span></h6>

                  </div>
                </div>
                <form id="dreamit-form">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 mb-4">
                      <div className="from-box">
                        <input defaultValue={energyDelegate.toString(10)} onInput={() => this.setEnergiaEnVenta()} type="text" id="energy" placeholder="Energy to Delegate" required />
                      </div>
                    </div>
                    <div className="col-lg-12 col-sm-12 mb-4" style={{ color: "white" }}>
                      For lock {trxDelegate.dp(0).toString(10)} TRX
                      <h6 id="trx-reward">You will receive: ~ {ciroRecibe.toString(10)} CIRO / day </h6>
                    </div>
                  </div>
                  <div className="from-box">
                    <button type="button" className="btn btn-primary w-100" onClick={() => this.sellEnergy()}>Delegate {energyDelegate.dp(0).toString(10)} Energy Now!</button>

                  </div>
                </form>
                <div id="status"></div>

                <div className="small-text mt-3">
                  <h6><small><em style={{ color: "white" }}>Energy will be locked for a period of 30 days, and the prices shown are for this period only.</em></small></h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container'>
        <div className='col'>
          <button type='button' className='btn btn-primary' onClick={() => this.claimCiro()}>Claim CIRO</button>
        </div>
      </div>

      <div className="table-section pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="dreamit-section-title  pb-3">
                <h1>Mining <span>CIRO</span></h1>
                <p><span className="table-title">+0.36%</span> Market up in the last 24 hours</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="explore_nav text-right">
                <div className="explore_menu">
                  <form action="#">
                    <select name="catagories" id="catagories">
                      <option value="volvo">All Catagories</option>
                      <option value="volvo">Video Game Items</option>
                      <option value="volvo">Art</option>
                      <option value="volvo">Music</option>
                      <option value="volvo">Domain Names</option>
                    </select>
                    <select name="cars" id="cars">
                      <option value="7days">7 Days</option>
                      <option value="8days">8 Days</option>
                      <option value="9days">9 Days</option>
                      <option value="5days">5 Days</option>
                    </select>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="table-reponsive box">
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th> <span>#</span> Currency</th>
                    <th>$ Price</th>
                    <th>24H Change</th>
                    <th>Market Cap.</th>
                    <th>T. Supply</th>
                    <th>24H Volume</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="single">
                    <td> <span>1</span> <img src="assets/images/resource/ra-1.png" alt="" /><h6>Bitcoin <span className="img-text">BTC</span></h6></td>
                    <td>$53,967.089</td>
                    <td><img className="images" src="assets/images/resource/icon7.png" alt="" /><span className="color-1">5.43%</span></td>
                    <td>0.05M</td>
                    <td>1.5K</td>
                    <td>68.5K</td>
                  </tr>
                  <tr className="one">
                    <td> <span>2</span> <img src="assets/images/resource/ra-2.png" alt="" /><h6>Ethereum <span className="img-text">ETH</span></h6></td>
                    <td>$98,967.056</td>
                    <td><img className="images" src="assets/images/resource/icon8.png" alt="" /> <span className="color-2">6.85</span></td>
                    <td>10.80M</td>
                    <td>5.5K</td>
                    <td>85.09K</td>
                  </tr>
                  <tr className="single">
                    <td><span>3</span><img src="assets/images/resource/ra-3.png" alt="" /><h6>Tether <span className="img-text">THR</span> </h6></td>
                    <td>$44,967.090</td>
                    <td><img className="images" src="assets/images/resource/icon7.png" alt="" /><span className="color-1">3.96%</span></td>
                    <td>0.05M</td>
                    <td>0.3k</td>
                    <td>100k</td>
                  </tr>
                  <tr className="one">
                    <td> <span>5</span> <img src="assets/images/resource/ra-5.png" alt="" /><h6>Binance Coin <span className="img-text">BNC</span></h6></td>
                    <td>$67,967.070</td>
                    <td><img className="images" src="assets/images/resource/icon8.png" alt="" /><span className="color-2">8.90%</span></td>
                    <td>0.07M</td>
                    <td>45K</td>
                    <td>98.9K</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>)
  }


}

export default Buyer;